/**
 * O contrato deste bundle, lido de `import.meta.env` (issue #996, etapa 1).
 *
 * A leitura é PREGUIÇOSA e memoizada. O que isso compra é modesto e vale dizer com
 * precisão: quem importa deste módulo (ou de `config/apps.ts`) apenas TIPOS, ou só as
 * funções que recebem o contrato por parâmetro, não paga a leitura. Não é uma promessa
 * de que nada avalia o contrato no import — `services/api.ts`, `store/auth.ts` e
 * `components/MetricsIntegrationCard.tsx` precisam do valor no topo do módulo e o
 * resolvem lá, de propósito: é onde o `axios.create` e a chave de sessão são montados.
 *
 * O `import.meta.env` que chega aqui é o mesmo objeto que o plugin de build validou
 * (`build/vitePluginDeploymentContract.ts` lê o `config.env` resolvido). Ou seja: num
 * bundle que existe, esta leitura não falha — o build teria falhado antes. O `throw`
 * cobre o caminho de quem rodar o código fora de um build validado (tooling, teste sem
 * env), e aí falhar é a resposta certa: era exatamente o `console.warn` seguido de URL
 * de produção que produziu o incidente de 2026-09-09.
 */
import { readDeploymentContract, type DeploymentContract } from './deploymentContract'

let contratoLido: DeploymentContract | null = null

export const getDeploymentContract = (): DeploymentContract => {
  if (!contratoLido) {
    contratoLido = readDeploymentContract(import.meta.env as unknown as Record<string, unknown>)
  }
  return contratoLido
}
